import { SocialLoginOption } from "@redotech/redo-model/auth/social-auth";
import { z } from "zod/v4";

export const convertSocialAuthToCustomerAuth = {
  name: "convertSocialAuthToCustomerAuth" as const,
  input: z.object({ provider: z.enum(SocialLoginOption), code: z.string() }),
  output: z.object({
    error: z.string().nullable(),
    customerAuthToken: z.string().optional(),
    customer: z
      .object({ name: z.string(), email: z.string(), customerId: z.string() })
      .optional(),
    orderId: z.string().optional(),
    warrantyId: z.string().optional(),
  }),
};
